import React, { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@mui/material";
import { Search } from "@mui/icons-material";
import { fetchDirectors } from "./directorService";
import DirectorList from "../../../DirectorList";
import DirectorEntryForm from "../../../DirectorEntryForm";
import { useSelector } from "react-redux";
import { selectNavHeight } from "../../../../../../../redux/navbar/navHeightSlice";

const DirectorPanel = ({ selectedDirector, setSelectedDirector }) => {
  const [directors, setDirectors] = useState([]);
  const [isDirectorListOpen, setIsDirectorListOpen] = useState(false);
  const [isEntryFormOpen, setIsEntryFormOpen] = useState(false);

  const navHeight = useSelector(selectNavHeight);

  const fetchData = async () => {
    try {
      const data = await fetchDirectors();
      setDirectors(data);
    } catch (error) {
      console.error("Error fetching directors:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDirectorChange = (event) => {
    const selectedId = event.target.value;
    const selectedDirectorObj = directors.find(
      (director) => director.id.toString() === selectedId
    );
    setSelectedDirector(selectedDirectorObj);
  };

  const handleOpenDirectorList = () => {
    setIsDirectorListOpen(true);
  };

  const handleCloseDirectorList = () => {
    setIsDirectorListOpen(false);
  };

  // const handleOpenDirectorForm = () => {
  //   setIsEntryFormOpen(true);
  // };

  const handleCloseDirectorForm = () => {
    setIsEntryFormOpen(false);
  };

  const handleRefreshDirectors = () => {
    fetchData();
  };

  return (
    <div className="flex">
      {/* Directors Table */}
      <div className="w-11/12 max-w-md p-6 mt-6 bg-white rounded-lg shadow-md border space-y-4 relative">
        <div className="flex items-center justify-between pb-2 border-b border-gray-300">
          <h2 className="text-lg font-bold text-gray-700">
            Connect with DOB Director
          </h2>
          <button
            type="button"
            onClick={handleOpenDirectorList}
            className="px-2 py-1 text-white bg-blue-600 rounded hover:bg-blue-500 focus:outline-none"
            title="Search Directors"
          >
            <Search />
          </button>
        </div>

        <div className="border-2 border-gray-300 rounded-lg shadow-md bg-white w-full">
          <div>
            <select
              onChange={handleDirectorChange}
              className="w-full rounded-lg overflow-hidden whitespace-nowrap text-ellipsis"
            >
              <option value="">Select a Director</option>
              {directors.map((director) => (
                <option key={director.id} value={director.id}>
                  {director.email}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* DirectorList Modal */}
      <Dialog
        open={isDirectorListOpen}
        onClose={handleCloseDirectorList}
        fullWidth
        maxWidth="lg"
        PaperProps={{
          style: {
            position: "absolute",
            top: navHeight,
            left: "50%",
            transform: "translateX(-50%)",
            margin: 4,
            transition: "width 0.3s ease, height 0.3s ease",
            width: "90%",
            height: `calc(100vh - ${navHeight + 8}px)`,
            overflow: "auto",
          },
        }}
      >
        <DialogContent>
          <DirectorList onClose={handleCloseDirectorList} />
        </DialogContent>
      </Dialog>

      {/* DirectorEntryForm */}
      <DirectorEntryForm
        open={isEntryFormOpen}
        onClose={handleCloseDirectorForm}
        refreshDirectors={handleRefreshDirectors}
        directorData={selectedDirector}
      />
    </div>
  );
};

export default DirectorPanel;
